import { UiStore } from './ui';

export * from './models';
export { useStore } from './useStore';

let store: UiStore;

export function initStore() {
  const _store = store ?? new UiStore();

  // If on the server, always create a new store
  if (typeof window === 'undefined') return _store;
  // If on the client, reuse the store
  if (!store) store = _store;

  return store;
}
